import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'popoverBody'];

  open(e) {
    e.preventDefault()
    // popoverBodyTargets not available due to wrapper, specifying stimulus controller, is within a loop
    document.querySelectorAll('.popover-body:not(.hidden)').forEach((popover) => popover.classList.add('hidden'))
    this.popoverBodyTarget.classList.remove('hidden')
  }

  select(e) {
    this.checkboxTarget.classList = e.target.classList
    this.close()
  }

  close() {
    this.popoverBodyTarget.classList.add('hidden')
  }
}
